import React from 'react';

import { useNavigate } from 'react-router-dom';

import CreateDivision from '../../forms/createDivision';
import DivisionsList from './divisionsList';
import Elevation from '../../themed/instruction-modals/elevation';
import Header from '../../blocks/header';
import Instruction from '../../themed/instruction-modals/instruction';

import { getTutorials, setActiveTutorial } from '../../../store/tutorials';
import { useAppDispatch, useAppSelector } from '../../../store/configureStore';
import { tutorialConstants } from '../../../utils/constants';

import className from './division.module.scss';
import routes from '../../../utils/routes';

const Division: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const tutorials = useAppSelector(getTutorials);

	const isActive = tutorials.activeTutorial === tutorialConstants.SETUP_DIVISIONS;

	const handleViewNextTutorial = () => {
		dispatch(setActiveTutorial(tutorialConstants.SETUP_PRIVILEGES));
		navigate(routes.addRole.fullPath);
	};

	return (
		<React.Fragment>
			<Instruction
				isVisible={isActive}
				onProceed={handleViewNextTutorial}
				title="SetUp Divisions!"
				message="Complete the form above to create a new division!"
			/>

			<Header subtitle="Create or update divisions" />

			<div className={className.division}>
				<Elevation isElevated={isActive}>
					<div className={className['division-body']}>
						<CreateDivision />
					</div>
				</Elevation>

				<div className={className['division-body']}>
					<DivisionsList />
				</div>
			</div>
		</React.Fragment>
	);
};

export default Division;
